export default "__VITE_ASSET__BFShMBSp__"